import { render, staticRenderFns } from "./SnackbarTemplate.vue?vue&type=template&id=caa86fa2"
import script from "./SnackbarTemplate.vue?vue&type=script&lang=js"
export * from "./SnackbarTemplate.vue?vue&type=script&lang=js"
import style0 from "./SnackbarTemplate.vue?vue&type=style&index=0&id=caa86fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports